export enum AmbidexChainId {
  HEDERA_MAINNET = 1099,
  HEDERA_TESTNET = 2099,
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
}
